import styled from 'styled-components';

const TextColumn = styled.div`
  ${({ align }) => align && `text-align: ${align}`};
  cursor: ${({ onClick }) => (typeof onClick === 'function' ? 'pointer' : 'default')};
`;

export default TextColumn;
